export default class User {
    /**
     * ID of the instance
     */
    public id = '';

    /**
     * The users first name.
     */
    public firstName = '';

    /**
     * The users last name.
     */
    public lastName = '';

    /**
     * Username of the user.
     */
    public username = '';

    /**
     * Email of the user.
     */
    public email = '';

    /**
     * Organization group memberships
     */
    public memberOf: string[] = [];

    public createdAt: Date = new Date(0);
    public updatedAt: Date = new Date(0);

    public getOrganizationUnits(): string[] {
        const res: string[] = [];
        const filtered: string[] = this.memberOf.filter((perm: string) =>
            perm.indexOf('ou=terepi adatgyujto,ou=bpkozut groups,dc=bpkozut,dc=lan') > 0 &&
            perm.indexOf('cn=users') >= 0
        );
        filtered.map(perm => res.push(this.parseMemberOfItem(perm)));
        return res;
    }

    public isAdminIn(name: string): boolean {
        const filtered: string[] = this.memberOf.filter((perm: string) =>
            perm.indexOf('ou=terepi adatgyujto,ou=bpkozut groups,dc=bpkozut,dc=lan') > 0 &&
            perm.indexOf('cn=' + name) >= 0 &&
            perm.indexOf('cn=admins') >= 0
        );
        return filtered.length === 1 ? true : false;
    }

    private parseMemberOfItem(item: string): string {
        item = item.slice(0, item.indexOf('ou=terepi adatgyujto,ou=bpkozut groups,dc=bpkozut,dc=lan'));
        item = item.replace('cn=users,', '');
        item = item.replace(',', '');
        item = item.replace('cn=', '');
        return item;
    }

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.id) {
            this.id = model.id;
        }
        if (model.firstName) {
            this.firstName = model.firstName;
        }
        if (model.lastName) {
            this.lastName = model.lastName;
        }
        if (model.username) {
            this.username = model.username;
        }
        if (model.email) {
            this.email = model.email;
        }
        if (model.memberOf) {
            this.memberOf = model.memberOf;
        }
        if (model.createdAt) {
            this.createdAt = new Date(model.createdAt);
        }
        if (model.updatedAt) {
            this.updatedAt = new Date(model.updatedAt);
        }
    }

    public isSuperAdminIn(ouToCheck: string): boolean {
        for (let i = 0; i < this.memberOf.length; i++) {
            if (this.memberOf[i].indexOf(ouToCheck) > -1 &&
            this.memberOf[i].indexOf('cn=admins') === 0) {
                return true;
            }
        }
        return false;
    }

    public isInOu(ouToCheck: string): boolean {
        const filteredOus = this.memberOf.filter((ou: string) =>
            ou.indexOf(ouToCheck) > -1);
        return filteredOus.length === 1;
    }
}
